<template>
  <div id="nc_container">
    <HEADER></HEADER>
    <div class="nc_header">
      <div id="star_box">
        <div id="stars_box" class="space">
          <!-- <div v-for="(i,index) in star_counts
          " :key="index" class="star_wrap" ref="one">
            <img src="../assets/img/star.png" alt="#" ref="two" />
          </div> -->

          <div class="star"></div>
          <div class="star star1"></div>
          <div class="star star2"></div>
          <div class="star star3"></div>
        </div>
      </div>
      <div class="banner">
          <img :data-src="require('../assets/img/main_bg.jpg')">
      </div>
      <div class="nc_header_content">

        <h1 class="ncmps">N-COMPASS</h1>
        <h1>为您解答流量数据中的任何问题</h1>
        <div class="video_switch" @click="fullScreen()">
          <div class="triangle"></div>观 看 视 频
        </div>
      </div>
      <div class="nc_header_information">
        <div class="nc_header_information_list" @mouseover="coverageMouseover(index)" @mouseout="coverageMouseout(index)" v-for="(item,index) in information_list" :key="index" @click="informationDetails(item.id)">
          <img :src='item.file' style="padding-right:8px;margin-bottom:-3px" v-show="!item.show">
          <img :src='item.filehover' style="padding-right:8px;margin-bottom:-3px" v-show="item.show">
          <span>资讯：</span>
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
    <div class="why_choose_us">
      <!-- <div class="wave"></div> -->
      <div class="content">
        <h2>WHY CHOOSE US</h2>
        <p>为什么选择我们</p>
      </div>
    </div>
    <div class="nc_products">
      <div class="nc_products_inner">
        <div class="nc_products_one w">
          <svg width="100%" height="100%">
            <!-- 网格 -->
            <!-- <image width='1200' height='900' x='0' y='51' xlink:href="../assets/img/svg_grid.svg" class='svg_grid' /> -->
            <image
              width="828"
              height="540"
              x="224"
              y="202"
              xlink:href="../assets/img/svg_stage.svg"
            />
            <!-- 桥 -->
            <image
              x="370"
              y="490"
              width="226"
              height="146"
              xlink:href="../assets/img/brige01.svg"
              class="img1"
            />
            <image
              x="620"
              y="254"
              width="25"
              height="55"
              xlink:href="../assets/img/linear_light.svg"
              class="api2"
            />
            <image
              x="947"
              y="445"
              width="25"
              height="55"
              xlink:href="../assets/img/linear_light.svg"
              class="api2"
            />
            <g class="svg_path" transform="translate(0,0)">
              <path
                d="M462 794 L530 744 L280 592 L338 552"
                stroke="rgba(0,234,237,.2)"
                fill="transparent"
                class="path1"
              />
              <path
                d="M392 749 L458 701 L280 592 L338 552"
                stroke="rgba(0,234,237,.1)"
                fill="transparent"
                class="path2"
              />
              <path
                d="M323 704 L374 668 L250 592 L321 544"
                stroke="rgba(0,234,237,.1)"
                fill="transparent"
                class="path3"
              />
              <path
                d="M252 659 L305 625 L250 592 L321 544"
                stroke="rgba(0,234,237,.1)"
                fill="transparent"
                class="path4"
              />
              <path
                d="M188 614 L305 536"
                class="path5"
                stroke="rgba(0,234,237,.2)"
                fill="transparent"
              />
              <!-- 小路径开始 -->
              <path
                d="M606 380 L590 370"
                stroke="rgba(0,234,237,.8)"
                class="small_path4"
                fill="transparent"
              />
              <path
                d="M560 420 L535 405"
                stroke="rgba(0,234,237,.8)"
                fill="transparent"
                class="small_path1"
              />
              <path
                d="M758 540 L780 553"
                stroke="rgba(0,234,237,.8)"
                class="small_path2"
                fill="transparent"
              />
              <path
                d="M818 504 L839 516"
                stroke="rgba(0,234,237,.8)"
                class="small_path3"
                fill="transparent"
              />
              <!-- 小路径结束 -->
              <path
                d="M763 386 L784 372 L784 328 L840 295"
                stroke="rgba(0,234,237,.8)"
                fill="transparent"
                class="path6"
              />
              <path
                d="M783 396 L804 382 L804 338 L860 305"
                stroke="rgba(0,234,237,.8)"
                fill="transparent"
                class="path7"
              />
              <path
                d="M803 406 L824 392 L824 348 L880 315"
                stroke="rgba(0,234,237,.8)"
                fill="transparent"
                class="path8"
              />
              <path
                d="M661 626 L704 598 L595 531 L630 508"
                stroke="rgba(0,234,237,.4)"
                fill="transparent"
                class="path9"
              />
              <path
                d="M643 626 L687 598 L580 531 L615 508"
                stroke="rgba(0,234,237,.4)"
                fill="transparent"
                class="path10"
              />
              <path
                d="M625 626 L670 598 L565 531 L600 507"
                stroke="rgba(0,234,237,.4)"
                fill="transparent"
                class="path11"
              />
              <path
                d="M607 626 L653 598 L550 531 L592 502"
                stroke="rgba(0,234,237,.4)"
                fill="transparent"
                class="path12"
              />
              <path
                d="M400 532 L565 625"
                stroke="rgba(0,234,237,.4)"
                fill="transparent"
                class="path13"
              />
              <path
                d="M410 520 L606 630"
                stroke="rgba(0,234,237,.4)"
                fill="transparent"
                class="path14"
              />
            </g>
            <!-- 数据采集 -->
            <image width="42" height="36" x="305" y="517" xlink:href="../assets/img/ex_sjcj.svg" />
            <!-- 数据统计 -->
            <image width="42" height="36" x="550" y="652" xlink:href="../assets/img/ex_sjtj.svg" />
            <!-- taffic data -->
            <image
              width="285"
              height="160"
              x="675"
              y="560"
              xlink:href="../assets/img/traffic_date.svg"
            />
            <!-- 作战指挥 -->
            <image width="78" height="54" x="830" y="265" xlink:href="../assets/img/ex_zhzx.svg" />
            <!-- AI算法文字 -->
            <image width="95" height="63" x="732" y="486" xlink:href="../assets/img/AIsfzx.svg" />

            <!-- 数据采集 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(0,$event)"
              @mouseout="setSvgAnimate(1);handleSvgout($event)"
            >
              <image
                x="300"
                y="365"
                width="136"
                height="182"
                xlink:href="../assets/img/sjcj.svg"
                class="img1"
              />
              <!-- hover -->
              <g>
                <image
                  x="300"
                  y="365"
                  width="136"
                  height="182"
                  xlink:href="../assets/img/sjcj_yellow.svg"
                  class="img2 targetimg"
                />
                <image
                  x="300"
                  y="365"
                  width="136"
                  height="182"
                  xlink:href="../assets/img/test11.gif"
                  class="img2 targetimg"
                />
              </g>
            </g>
            <!-- 数据统计 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(1,$event)"
              @mouseout="setSvgAnimate(2);handleSvgout($event)"
            >
              <image
                x="545"
                y="500"
                width="136"
                height="184"
                xlink:href="../assets/img/sjtj.svg"
                class="img1"
              />
              <!-- hover -->
              <g>
                <image
                  x="545"
                  y="500"
                  width="136"
                  height="184"
                  xlink:href="../assets/img/sjtj_yellow.svg"
                  class="img2 targetimg"
                />
                <image
                  x="545"
                  y="500"
                  width="136"
                  height="184"
                  xlink:href="../assets/img/sjtj_hover.gif"
                  class="img2 targetimg"
                />
                <image
                  x="545"
                  y="500"
                  width="136"
                  height="184"
                  xlink:href="../assets/img/sjtj_spot.svg"
                  class="img2 targetimg"
                />
              </g>
            </g>
            <!-- AI算法 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(2,$event)"
              @mouseout="setSvgAnimate(3);handleSvgout($event)"
            >
              <image
                width="300"
                height="208"
                x="532"
                y="346"
                xlink:href="../assets/img/aisuanfa.svg"
                class="img1"
              />
              <!-- hover -->
              <g>
                <image
                  width="300"
                  height="208"
                  x="532"
                  y="346"
                  xlink:href="../assets/img/aisf_hover.gif"
                  class="img2 targetimg"
                />
              </g>
            </g>

            <!-- 数据 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(3,$event)"
              @mouseout="setSvgAnimate(4);handleSvgout($event)"
            >
              <image
                x="472"
                y="372"
                width="75"
                height="43"
                xlink:href="../assets/img/icon_sj_hover.svg"
                class="img1"
              />
              <g>
                <image
                  x="472"
                  y="372"
                  width="75"
                  height="43"
                  xlink:href="../assets/img/icon_sj.svg"
                  class="img2"
                />
              </g>
            </g>

            <!-- 告警 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(4,$event)"
              @mouseout="setSvgAnimate(5);handleSvgout($event)"
            >
              <image
                x="532"
                y="336"
                width="75"
                height="43"
                xlink:href="../assets/img/icon_gj_hover.svg"
                class="img1"
              />
              <g>
                <image
                  x="532"
                  y="336"
                  width="75"
                  height="43"
                  xlink:href="../assets/img/icon_gj.svg"
                  class="img2"
                />
              </g>
            </g>

            <!-- 拓扑 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(5,$event)"
              @mouseout="setSvgAnimate(6);handleSvgout($event)"
            >
              <image
                x="762"
                y="542"
                width="75"
                height="43"
                xlink:href="../assets/img/icon_tp_hover.svg"
                class="img1"
              />
              <g>
                <image
                  x="762"
                  y="542"
                  width="75"
                  height="43"
                  xlink:href="../assets/img/icon_tp.svg"
                  class="img2"
                />
              </g>
            </g>

            <!-- 安全 -->
            <g
              class="hoverbox autoplay"
              @mouseenter="clearTimer(6,$event)"
              @mouseout="setSvgAnimate(7);handleSvgout($event)"
            >
              <image
                x="822"
                y="506"
                width="75"
                height="43"
                xlink:href="../assets/img/icon_anquan_hover.svg"
                class="img1"
              />
              <g>
                <image
                  x="822"
                  y="506"
                  width="75"
                  height="43"
                  xlink:href="../assets/img/icon_anquan.svg"
                  class="img2"
                />
              </g>
            </g>

            <!-- 指挥中心幕布 -->
            <g
              class="hoverbox_sp autoplay"
              @mouseenter="clearTimer(7,$event)"
              @mouseout="setSvgAnimate(7);handleSvgout($event)"
            >
              <image
                width="316"
                height="284"
                x="738"
                y="103"
                xlink:href="../assets/img/zhzx_stage.svg"
                class="img1"
              />
              <g>
                <image
                  width="316"
                  height="284"
                  x="738"
                  y="103"
                  xlink:href="../assets/img/zhzx.png"
                  class="img2"
                />
                <image
                  width="316"
                  height="284"
                  x="738"
                  y="103"
                  xlink:href="../assets/img/zhzx_yellow.svg"
                  class="img2"
                />
                <image
                  width="316"
                  height="284"
                  x="738"
                  y="103"
                  xlink:href="../assets/img/zhzx_hover.gif"
                  class="img2"
                />
              </g>
            </g>

            <g class="svg_title" transform="translate (0,0)">
              <image
                x="-6"
                y="124"
                width="72"
                height="52"
                class="num_title"
                xlink:href="../assets/img/svg/no1.svg"
              />
              <text class="title_s" x="0" y="202" fill="#FFDE2E">{{svg_config_title}}</text>
              <foreignObject x="0" y="226" width="400" height="160">
                <div xmlns="http://www.w3.org/1999/xhtml" class="title_t">{{svg_config_content}}</div>
              </foreignObject>
            </g>
            <g class="svg_icon" transform="translate(0,0)">
              <image x="120" y="610" width="78" height="64" xlink:href="../assets/img/api_top.svg" />
              <image
                class="api"
                x="120"
                y="610"
                width="78"
                height="64"
                xlink:href="../assets/img/api_bot.svg"
              />

              <image x="190" y="655" width="78" height="64" xlink:href="../assets/img/log_top.svg" />
              <image
                class="api"
                x="190"
                y="655"
                width="78"
                height="64"
                xlink:href="../assets/img/log_bot.svg"
              />

              <image x="260" y="700" width="78" height="64" xlink:href="../assets/img/flow_top.svg" />
              <image
                class="api"
                x="260"
                y="700"
                width="78"
                height="64"
                xlink:href="../assets/img/flow_bot.svg"
              />

              <image x="330" y="745" width="78" height="64" xlink:href="../assets/img/cmdb_top.svg" />
              <image
                class="api"
                x="330"
                y="745"
                width="78"
                height="64"
                xlink:href="../assets/img/cmdb_bot.svg"
              />

              <image x="400" y="790" width="78" height="64" xlink:href="../assets/img/itom_top.svg" />
              <image
                class="api"
                x="400"
                y="790"
                width="78"
                height="64"
                xlink:href="../assets/img/itom_bot.svg"
              />
            </g>
          </svg>
        </div>
      </div>
      <div class="nc_products_content">
        <div class="w">
          <div class="nc_pds_left pt200 wow slideInLeft">
            <h2>
              <img :data-src="require('../assets/img/svg/no2.svg')" alt class="svg_num" />
            </h2>
            <span>数据可视化</span>
            <p>
              轻松应对各种数据消费场景。用户可通过鼠标拖拽等灵活操作，10分钟内完成大屏幕界面的创建，
              内置各种酷炫可视化控件，能满足您不同的可视化需求。
            </p>
            <div class="detail">
              <span @click='$router.push({path:"product"})'>更多详情 ></span>
              <span @click='videoIsShow = true;videoIsFull=false;'>观看视频 ></span>
            </div>
          </div>
          <div class="nc_pds_right pt128 wow slideInRight">
            <img :data-src="require('../assets/img/02sjksh.svg')" alt />
            <img :data-src="require('../assets/img/02.gif')" alt />
          </div>
        </div>

        <!-- 视频 -->
        <div id="video_wrap" v-show='videoIsShow'>
            <div class="video" v-if="!videoIsFull">
              <div class="close"  @click='handleVideoClose'>X</div>
              <video ref='video2' src="../assets/libs/DB3.mp4" controls></video>
            </div>
            <div class="video" v-show="videoIsFull">
              <div class="close" @click='handleVideoClose'>X</div>
              <video ref='video'  id="fullVideo" src="../assets/libs/ncompass.mp4" controls></video>
            </div>
        </div>
      </div>
      <div class="nc_products_content">
        <div class="w">
          <div class="nc_pds_right wow slideInLeft">
            <img
              style="width:514px;height:500px;"
              :data-src="require('../assets/img/03yhty.png')"
              alt
            />
            <img :data-src="require('../assets/img/03.gif')" alt />
            <img :data-src="require('../assets/img/cloud1.svg')" alt class="cloud1" />
            <img :data-src="require('../assets/img/cloud2.svg')" alt class="cloud2" />
          </div>
          <div class="nc_pds_left pt200 wow slideInRight" style="padding-left:80px;">
            <h2>
              <img :data-src="require('../assets/img/svg/no3.svg')" alt class="svg_num" />
            </h2>
            <span>用户体验监控</span>
            <p>
              搭建真实用户体验的智能监控体系，基于机器学习及异常检测算法，快速智能感知异常事件， 消除监控盲区，解决运维被动的难题。
            </p>
            <div class="detail">
              <span @click='$router.push({path:"product"})'>更多详情 ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="nc_products_content">
        <div class="w">
          <div class="nc_pds_left pt200 wow slideInLeft">
            <h2>
              <img :data-src="require('../assets/img/svg/no4.svg')" alt class="svg_num" />
            </h2>
            <span>智能分析</span>
            <p>
              全量的采集、储存、分析，结合AI智能算法及专家知识图谱，让运维人员更从容的处理遇到的各种问题。
            </p>
            <div class="detail">
              <span @click='$router.push({path:"product"})'>更多详情 ></span>
            </div>
          </div>
          <div class="nc_pds_right wow slideInRight">
            <img style="width:500px;height:468px;margin-left:80px;" src="../assets/img/04.svg" alt />
            <img
              style="width:500px;height:468px;margin-left:80px;z-index:11;"
              :data-src="require('../assets/img/042.svg')"
              alt
            />
            <img
              style="width:500px;height:468px;margin-left:80px;"
              :data-src="require('../assets/img/04gif.gif')"
              alt
            />
            <svg width="100%" height="100%">
              <circle r="2" fill="#FFA1DD">
                <animateMotion
                  path="M412 218 L412 184 L512 243 L512 380"
                  begin="0s"
                  dur="2s"
                  repeatCount="indefinite"
                  repeatDur="undefineds"
                  rotate="auto"
                  calcMode="linear"
                />
              </circle>
            </svg>
          </div>
        </div>
      </div>
      <div class="nc_products_content">
        <div class="w">
          <div class="nc_pds_right wow slideInLeft">
            <svg width="100%" height="100%">
              <image width="550" height="472" x="0" y="128" xlink:href="../assets/img/05.svg" />
              <g>
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="360"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="340"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="320"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="300"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="280"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="260"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink1"
                  width="45"
                  height="44"
                  x="65"
                  y="240"
                  xlink:href="../assets/img/box_def.svg"
                />
              </g>
              <g>
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="120"
                  y="392"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="120"
                  y="372"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="175"
                  y="424"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="175"
                  y="404"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="155"
                  y="310"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="155"
                  y="290"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink2"
                  width="45"
                  height="44"
                  x="210"
                  y="342"
                  xlink:href="../assets/img/box_def.svg"
                />
              </g>
              <g>
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="265"
                  y="374"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="265"
                  y="354"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="235"
                  y="260"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="235"
                  y="240"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="235"
                  y="220"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="235"
                  y="200"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink3"
                  width="45"
                  height="44"
                  x="235"
                  y="180"
                  xlink:href="../assets/img/box_def.svg"
                />
              </g>
              <g>
                <image
                  class="blink4"
                  width="45"
                  height="44"
                  x="290"
                  y="292"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink4"
                  width="45"
                  height="44"
                  x="290"
                  y="272"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink4"
                  width="45"
                  height="44"
                  x="345"
                  y="324"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink4"
                  width="45"
                  height="44"
                  x="345"
                  y="304"
                  xlink:href="../assets/img/box_def.svg"
                />
                <image
                  class="blink4"
                  width="45"
                  height="44"
                  x="345"
                  y="284"
                  xlink:href="../assets/img/box_def.svg"
                />
              </g>
            </svg>
          </div>
          <div class="nc_pds_left pt200 wow slideInRight" style="padding-left:80px;">
            <h2>
              <img :data-src="require('../assets/img/svg/no5.svg')" alt class="svg_num" />
            </h2>
            <span>应用梳理</span>
            <p>
              基于真实的应用访问数据及关联分析，自动生成数据中心、网络区域、业务系统、应用
              、IP、应用负载、防火墙等多维度画像，快速梳理数据中心端到端访问流程。
            </p>
            <div class="detail">
              <span @click='$router.push({path:"product"})'>更多详情 ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="nc_products_content">
        <div class="w">
          <div class="nc_pds_left pt200 wow slideInLeft">
            <h2>
              <img :data-src="require('../assets/img/svg/no6.svg')" alt class="svg_num" />
            </h2>
            <span>安全行为回溯</span>
            <p>
              基于用户行为的画像分析，运用大数据算法，解决弱特征安全攻击的防护，化繁为简，
              轻松监控异常访问关系，实时告警并溯源攻击轨迹。
            </p>
            <div class="detail">
              <span @click='$router.push({path:"product"})'>更多详情 ></span>
            </div>
          </div>
          <div class="nc_pds_right wow slideInRight">
            <img
              style="width:522px;height:476px;margin-left:80px;"
              :data-src="require('../assets/img/sec06.svg')"
              alt
            />
            <img
              style="width:522px;height:476px;margin-left:80px;"
              :data-src="require('../assets/img/sec061.svg')"
              alt
            />
            <img
              style="width:522px;height:476px;margin-left:80px;"
              :data-src="require('../assets/img/sec_hover.gif')"
              alt
            />
            <img
              :data-src="require('../assets/img/linear_light.svg')"
              alt
              class="breath_light api2"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="nc_cloud_data">
      <div class="w">
        <div class="nc_cloud_title">
          <h2>CLOUD DATA VISUALIZATION</h2>
          <P>云端数据可视化</P>
        </div>
        <div class="nc_cloud_content">
          <ul>
            <li @mouseenter="handleCloud($event)" @mouseout="handleCloudOut($event)">
              <img :data-src="require('../assets/img/self_cloud.svg')" alt />
              <img :data-src="require('../assets/img/self_cloud2.svg')" alt />
              <p>私有云部署方案</p>
            </li>
            <li @mouseenter="handleCloud($event)" @mouseout="handleCloudOut($event)" ref="targetli">
              <img :data-src="require('../assets/img/public_cloud.svg')" alt />
              <img :data-src="require('../assets/img/public_cloud2.svg')" alt />
              <p>公有云部署方案</p>
            </li>
            <li @mouseenter="handleCloud($event)" @mouseout="handleCloudOut($event)">
              <img :data-src="require('../assets/img/mix_cloud.svg')" alt />
              <img :data-src="require('../assets/img/mix_cloud2.svg')" alt />
              <p>混合云部署方案</p>
            </li>
            <li
              @mouseenter="handleCloud($event)"
              @mouseout="handleCloudOut($event)"
              style="margin-right:0px;"
            >
              <img :data-src="require('../assets/img/dp_cloud2.svg')" alt />
              <img :data-src="require('../assets/img/dp_cloud.svg')" alt />
              <p>容器云部署方案</p>
            </li>
          </ul>
        </div>
        <div class="nc_cloud_more">
          <p class="download">方 案 下 载</p>更多云端方案咨询： 400-666-8216
        </div>
      </div>
    </div>
    <div class="nc_who_choose_us">
      <div class="w">
        <div class="who_us_title">
          <h2>WHO CHOOSE US</h2>
          <p>哪些用户选择了我们</p>
        </div>
        <swiper class="swiper1 swiper-no-swiping" :options="swiperOption">
          <swiper-slide class="flex_box">
            <div class="left">
              <img :data-src="require('../assets/img/hangye1.svg')" alt="">
            </div>
            <div class="right">
              <p>软硬一体化的数据可视化解决方案，采集数据中心的网络流量并进行可视化分析，</p>
              <p>为用户提供实时主动监控预警，服务访问关系梳理组合监控范围及场景。</p>
              <p class="people_say">新华社</p>
            </div>
          </swiper-slide>
          <swiper-slide class="flex_box">
            <div class="left">
              <img :data-src="require('../assets/img/hangye2.svg')" alt="">
            </div>
            <div class="right">
              <p>nCompass帮助新奥建立了全新的IT服务质量标准!</p>
              <p class="people_say">新奥集团</p>
            </div>
          </swiper-slide>
          <swiper-slide class="flex_box">
            <div class="left">
              <img :data-src="require('../assets/img/hangye3.svg')" alt="">
            </div>
            <div class="right">
              <p>方便全网设备的集中维护，以及随时掌握网络的运行状态，</p>
              <p>为网络扩容和规划优化提供现代化的工具。</p>
              <p class="people_say">人民网</p>
            </div>
          </swiper-slide>
          <swiper-slide class="flex_box">
            <div class="left">
              <img :data-src="require('../assets/img/hangye4.svg')" alt="">
            </div>
            <div class="right">
              <p>f5和nCompass合作的理由，利用f5的无探针应用数据采集技术和nCompass的机器学习以及可视化能力结合，实现应用可视化运维；</p>
              <p>同时将AI分析的结果通过API与f5联动实现在线应用路由管理，提升应用可视化，与CI/CD集成实自动化运维，降低Opex。</p>
              <p class="people_say">合作伙伴f5公司</p>
            </div>
          </swiper-slide>
          <swiper-slide class="flex_box">
            <div class="left">
              <img :data-src="require('../assets/img/hangye5.svg')" alt="">
            </div>
            <div class="right">
              <p>平安在引入并在生产环境部署nCompass产品，对关键节点全流量镜像，非关键流量实时采样。</p>
              <p>通过NC设备实现了对网络流量可视化，故障定位和恢复时效都有了大幅提升。</p>
              <p class="people_say">平安科技</p>
            </div>
          </swiper-slide>
          <div class="yinhao"></div>
          <div class="yinhao2"></div>
        </swiper>
        <swiper class="swiper2" :options="swiperOption2">
          <swiper-slide class="swiper2_box">
            <img :data-src='require("../assets/img/carousel/gjdw.png")' alt />
            <img :data-src='require("../assets/img/carousel/hxyh.png")' alt />
            <img :data-src='require("../assets/img/carousel/xhs.png")' alt />
            <img :data-src='require("../assets/img/carousel/zgsh.png")' alt />
            <img :data-src='require("../assets/img/carousel/he.png")' alt />
          </swiper-slide>
          <swiper-slide class="swiper2_box">
            <img :data-src='require("../assets/img/carousel/al.png")' alt />
            <img :data-src='require("../assets/img/carousel/bfmz.png")' alt />
            <img :data-src='require("../assets/img/carousel/bfzf.png")' alt />
            <img :data-src='require("../assets/img/carousel/cchx.png")' alt />
            <img :data-src='require("../assets/img/carousel/dyyh.png")' alt />
          </swiper-slide>
          <swiper-slide class="swiper2_box">
            <img :data-src='require("../assets/img/carousel/gjxx.png")' alt />
            <img :data-src='require("../assets/img/carousel/gmyf.png")' alt />
            <img :data-src='require("../assets/img/carousel/gyns.png")' alt />
            <img :data-src='require("../assets/img/carousel/hnrlzy.png")' alt />
            <img :data-src='require("../assets/img/carousel/hxbx.png")' alt />
          </swiper-slide>
          <swiper-slide class="swiper2_box">
            <img :data-src='require("../assets/img/carousel/jsyh.png")' alt />
            <img :data-src='require("../assets/img/carousel/lhdc.png")' alt />
            <img :data-src='require("../assets/img/carousel/onstar.png")' alt />
            <img :data-src='require("../assets/img/carousel/pakj.png")' alt />
            <img :data-src='require("../assets/img/carousel/pdyh.png")' alt />
          </swiper-slide>
          <swiper-slide class="swiper2_box">
            <img :data-src='require("../assets/img/carousel/pzh.png")' alt />
            <img :data-src='require("../assets/img/carousel/qsyh.png")' alt />
            <img :data-src='require("../assets/img/carousel/rmw.png")' alt />
            <img :data-src='require("../assets/img/carousel/sdny.png")' alt />
            <img :data-src='require("../assets/img/carousel/sdsh.png")' alt />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <WHO></WHO>
    <FOOTER></FOOTER>
  </div>
</template>

<script>
import HEADER from "../components/header.vue";
import FOOTER from "../components/footer.vue";
import WHO from "../components/who.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import imgUrl1 from "../assets/img/box_warning.svg";
import imgUrl2 from "../assets/img/box_def.svg";
import {getSiblings ,lazyLoad , preloadImage} from '../assets/js/func.js';
export default {
  components: {
    HEADER,
    FOOTER,
    WHO,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      imgUrl1: imgUrl1,
      imgUrl2: imgUrl2,
      videoIsShow:false,
      videoIsFull:false,
      swiperOption: {
        spaceBetween: 30,
        effect: "fade",
        autoplay: {
          delay: 3000
        },
        mousewheel: false
      },
      swiperOption2: {
        direction: "vertical",
        autoplay: {
          delay: 3000
        }
      },
      // banner星星总数量
      star_counts: 200,
      imgs: 5,
      imgs_cur: null,
      circle_animate: {
        color: 0.9,
        cishu: 5,
        dur: 2
      },
      svg_config_title: "多源数据采集",
      svg_config_content:"多维度数据采集，基于不同用户场景统一分析，消除运营数据信息孤岛，从而让大数据分析更加高效。",
      svg_title_arr: [
        {
          title: "多源数据采集",
          content:"多维度数据采集，基于不同用户场景统一分析，消除运营数据信息孤岛，从而让大数据分析更加高效。"
        },
        {
          title: "数据统计",
          content:"数据结构化处理（维度，指标），多层次、多维度的高效数据统计分析和处理能力。"
        },
        {
          title: "AI算法",
          content:"支持AI算法库及知识图谱，系统内置机器学习、异常检测、多维主因素、事件关联分析、预测等智能算法。"
        },
        {
          title: "智能监控",
          content:"搭建基于真实用户体验的智能监控体系，基于机器学习及异常检测算法，快速智能感知异常事件，消除监控盲区，解决运维被动难题。"
        },
        {
          title: "智能告警",
          content:"除了正常基线告警之外，系统内置覆盖众多故障场景的知识图谱。当发生告警事件时，系统可进行自动的智能分析，并提供分析结论报告，自动定位故障的根因，提升异常突发事件的处理效率。"
        },
        {
          title: "应用梳理",
          content:"应用访问数据及关联分析，自动生成数据中心、网络区域、业务系统、应用、IP、应用负载、防火墙等多维度画像，快速梳理数据中心端到端访问流程"
        },
        {
          title: "安全回溯",
          content:"基于用户行为的画像分析，运用大数据算法，解决弱特征安全攻击的防护，化繁为简，轻松监控异常访问关系，实时告警并溯源攻击轨迹。"
        },
        {
          title: "作战指挥中心",
          content:"多维数据源采集、统一管理，统一分析，让各个部门协同作战，更加从容的面对各种问题。"
        }
      ],
      timer: null,
      blink_timer:['timer1','timer2','timer3','timer4'],
      information_list:[]
    };
  },
  created(){
    this.getInformation()
  },
  methods: {
    setSvgAnimate(target) {
      window.clearInterval(this.timer);
      var i = target || 0;
      var t = document.querySelector(".num_title");
      var autoGroup = document.querySelectorAll(".autoplay");
      this.timer = setInterval(() => {
        this.changeSvgTitle(i);
        autoGroup[i].lastChild.childNodes.forEach(function(x) {
          x.style.opacity = 1;
        });
        if (i >= 1) {
          autoGroup[i - 1].lastChild.childNodes.forEach(function(x) {
            x.style.opacity = 0;
          });
        } else if(i == 0){
          autoGroup[7].lastChild.childNodes.forEach(function(x) {
            x.style.opacity = 0;
          });
        }
         // 只有默认显示标题数字
        if (i != 0) {
          t.style.display = "none";
        } else {
          t.style.display = "block";
        }
        i++;
        // 循环一遍后归0 重新开始
        if (i >= this.svg_title_arr.length) {
          i = 0;
        }
      }, 4000);
    },

    //-------------获取详情-------------
    getInformation(){
      fetch("https://www.ncmps.com/api/article/list",{
              method:"POST",
          }).then(res=>{
              res.json().then(res=>{
                if (res.code === 0) {
                  res.data.data.map(item=>{
                    item['file'] = require('../assets/img/coverage/file.png'),
                    item['filehover'] = require('../assets/img/coverage/filehover.png'),
                    item['show'] = false
                  })
                  this.information_list = res.data.data || []
                }
              })
          })
    },

    //-------------咨询详情-------------
    informationDetails(id){
       this.$router.push({path:'/detail',query: {id}})
    },

    coverageMouseover(e){
      this.information_list[e].show = !this.information_list[e].show
    },

    coverageMouseout(e){
       this.information_list[e].show = !this.information_list[e].show
    },

    fullScreen(){
      this.videoIsFull = true
      this.videoIsShow = true
      // var ele = document.getElementById('fullVideo');
      // ele.play()
      this.$refs.video.play()
      // if (ele.requestFullscreen) {
      //     ele.requestFullscreen();
      // } else if (ele.mozRequestFullScreen) {
      //     ele.mozRequestFullScreen();
      // } else if (ele.webkitRequestFullScreen) {
      //     ele.webkitRequestFullScreen();
      // }
    },
    changeSvgTitle(i) {
      this.svg_config_title = this.svg_title_arr[i].title;
      this.svg_config_content = this.svg_title_arr[i].content;
    },
    handleSvgout(e) {
      event.currentTarget.lastChild.childNodes.forEach(function(x) {
        x.style.opacity = 0;
      });
    },
    clearTimer(idx, e) {
      window.clearInterval(this.timer);
      var it = document.querySelectorAll(".autoplay");
      for (var i = 0; i < it.length; i++) {
        it[i].lastChild.childNodes.forEach(function(x) {
          x.style.opacity = 0;
        });
      };
      e.currentTarget.lastChild.childNodes.forEach(function(x) {
        x.style.opacity = 1;
      });
      this.changeSvgTitle(idx);
    },
    handleCloud(e) {
      this.$refs.targetli.className = "";
      e.currentTarget.className = "active_cloud";
      e.currentTarget.childNodes[0].style.opacity = 0;
      e.currentTarget.childNodes[1].style.opacity = 1;
    },
    handleCloudOut(e) {
      e.currentTarget.className = "";
      e.currentTarget.childNodes[0].style.opacity = 1;
      e.currentTarget.childNodes[1].style.opacity = 0;
    },
    createCircle(dom, begin, repeatDur) {
      var tar_g = dom.parentNode;
      var d = dom.getAttribute("d");
      var b = begin || 0;
      for (var i = 0; i < this.circle_animate.cishu; i++) {
        var str = `
          <circle r='1' fill="rgba(0,234,237,${(this.circle_animate.color -= 0.1)}">
            <animateMotion path="${d}" begin="${i / 40 + b}s" dur="${
          this.circle_animate.dur
        }s"  repeatCount="indefinite" repeatDur="${repeatDur}s"
          rotate="auto" calcMode="linear"></animateMotion>
          </circle>`;
        tar_g.innerHTML += str;
      };
      this.circle_animate.color = 0.9;
    },
    getPosition() {
      for (var i = 0 , count = this.$refs.one.length; i < count; i++) {
        var left =
          Math.floor(document.body.clientWidth * Math.random() - 20) + "px";
        var top = Math.floor(800 * Math.random()) + "px";
        this.$refs.one[i].style.left = left;
        this.$refs.one[i].style.top = top;
      }
    },
    boxBlink(boxs,timer) {
      window.clearInterval(this.blink_timer[timer]);
      this.blink_timer[timer] = setInterval(() => {

        var random = Math.floor(Math.random() * boxs.length);

        boxs[random].setAttribute("xlink:href", this.imgUrl1);

        for (var i = 0 , box_arr = boxs.length; i < box_arr - 1; i++) {
          getSiblings(boxs[random])[i].setAttribute(
            "xlink:href",this.imgUrl2
          );
        }

      }, 2500);
    },
    handleVideoClose(){
      this.videoIsShow = false
      this.$refs.video?.pause()
      this.$refs.video2?.pause()
    },
    throttle(func,wait){
      var previous = 0;
      return function(){
        let now = Date.now();
        let context = this;
        let args = arguments;
        if(now - previous > wait){
          func.apply(contenxt,args);
          previous = now;
        }
      }
    },
    boxBlink_listen(){
      window.addEventListener('scroll',()=>{
      var s_Top = document.documentElement.scrollTop;
      if(s_Top >= 3480 && s_Top <= 5100){
        this.throttle(this.boxBlink(document.querySelectorAll(".blink1"),0),2000);
        this.throttle(this.boxBlink(document.querySelectorAll(".blink2"),1),2000);
        this.throttle(this.boxBlink(document.querySelectorAll(".blink3"),2),2000);
        this.throttle(this.boxBlink(document.querySelectorAll(".blink4"),3),2000);
      }else{
        // 清除定时器
        for(var i = 0,count = this.blink_timer.length; i < count;i++){
          window.clearInterval(this.blink_timer[i])
        }
      }
    });
    },
    sleep(time){
      return new Promise((resolve)=> setTimeout(resolve,time,'sleep'));
    }
  },
  mounted() {
    // 开启路径动画
    this.createCircle(document.querySelector(".path1"));
    this.createCircle(document.querySelector(".path2"));
    this.createCircle(document.querySelector(".path3"));
    this.createCircle(document.querySelector(".path4"));
    this.createCircle(document.querySelector(".path5"));
    this.createCircle(document.querySelector(".path6"), 8);
    this.createCircle(document.querySelector(".path7"), 8);
    this.createCircle(document.querySelector(".path8"), 8);
    this.createCircle(document.querySelector(".path9"), 4);
    this.createCircle(document.querySelector(".path10"), 4);
    this.createCircle(document.querySelector(".path11"), 4);
    this.createCircle(document.querySelector(".path12"), 4);
    this.createCircle(document.querySelector(".path13"), 2);
    this.createCircle(document.querySelector(".path14"), 2);
    this.createCircle(document.querySelector(".small_path1"), 6);
    this.createCircle(document.querySelector(".small_path2"), 6);
    this.createCircle(document.querySelector(".small_path3"), 6);
    this.createCircle(document.querySelector(".small_path4"), 6);

    // 开启盒子闪烁
    this.boxBlink_listen();

    // svg动画轮播
    this.setSvgAnimate();
    // 用户无操作五分钟停止SVG动画
    this.sleep(100000).then((value)=>{
      window.clearInterval(this.timer)
    })
    // 图片懒加载
    lazyLoad(document.querySelectorAll("[data-src]"));
  },
  destroyed(){
    this.timer = null;
    for(var i = 0,count = this.blink_timer.length; i < count;i++){
        window.clearInterval(this.blink_timer[i])
    };
  }

};
</script>

<style lang='less' >
@import url("../assets/css/home.less");
</style>